import React, { Component} from 'react'
import { connect } from 'react-redux'
import { Row, Col, Card, Button } from 'react-bootstrap'
import Header from '../Header'
import Spinner from 'react-bootstrap/Spinner'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import 'moment/locale/es';
import data from '../../lib/backend/data'
import { Link } from 'react-router-dom'
import 'moment/locale/es';

class Clientes extends Component {
    constructor(props){
        super(props)
        this.state = {
            user: JSON.parse(localStorage.getItem('bumer_bknd_user')),
            id_establecimiento: this.props.match.params.id,
            establecimientos: [],
            establecimiento_seleccionado: false,
            habilitandoPago: false,
            tarifas: [],
            loadingMediosPagoActivos: true,
            tipos_pago: [],
            tipo_pago_seleccionado: '',
            clientes: [],
            total: 0
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleChangeTarifa = this.handleChangeTarifa.bind(this)
        this.handleChangeTipoPago = this.handleChangeTipoPago.bind(this)

    }

    handleChange(e){
        const { name, value } = e.target
        return this.setState({ [name]: value })
    }

    handleChangeTarifa(e){
        const { nueva_tarifa } = this.state
        const { name, value } = e.target
        nueva_tarifa[name] = value
        return this.setState({ nueva_tarifa })
    }

    componentDidMount(){
        const { id_establecimiento } = this.state
        this.getClientes(id_establecimiento)
    }

    getMediosPago(){
        const loading = 'loadingEsquemaPais'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/api/mediospago/list`,{
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(res => {
            if(!res){
                toast.error('No se obtuvieron datos del servidor')
                return this.setState({ [loading]: false })
            }
            if(res.errorMessage){
                toast.error(res.errorMessage)
                return this.setState({ [loading]: false })
            }
            this.setState({ [loading]: false, tipos_pago: res })
        })
        .catch(error => {
            toast.error("Error al realizar esta operación, intente nuevamente", this.state.toaststyle)
            this.setState({ [loading]: false })
        })
    }

    deshabilitarTipoPago(id){
        const { clientes } = this.state
        const loading = 'eliminando'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/api/mediospago?id=${id}`,{
            method:'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(res => {
            if(res.errorMessage){
                toast.error(res.errorMessage)
                return this.setState({ [loading]: false })
            }
            const i = clientes.findIndex(tipo => tipo._id === id)
            clientes.splice(i,1)
            toast.success('Desactivado exitosamente')
            this.setState({ clientes, [loading]: false })
        })
        .catch(error => {
            this.setState({ [loading]: false })
            toast.error("Error al realizar esta operación, intente nuevamente", this.state.toaststyle)
        })
    }
    habilitarTipoPago(){
        const { tipo_pago_seleccionado, id_establecimiento, clientes } = this.state
        if(!tipo_pago_seleccionado) return toast.error('El tipo de pago es requerido')
        const loading = 'habilitandoPago'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/api/mediospago`,{
            method:'POST',
            body: JSON.stringify( {
                id_establecimiento,
                tipo_pago_seleccionado
            } ),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(res => {
            console.log(res)
            if(res._id){ 
                clientes.unshift(res)
                toast.success('Guardado exitosamente')
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
                return this.setState({ [loading]: false })
            } else {
                toast.error('Ocurrió un error inesperado')
            }
            this.setState({ [loading]: false, clientes })
        })
        .catch(error => {
            this.setState({ [loading]: false })
            toast.error("Error al realizar esta operación, intente nuevamente", this.state.toaststyle)
        })
    }

    handleChangeTipoPago(e){
        const { value } = e.target
        return this.setState({ tipo_pago_seleccionado: value })
    }

    async getClientes(id_establecimiento){
        const loading = 'loadingMediosPagoActivos'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/api/customers/list?idestablecimiento=${id_establecimiento}`)
        .then(res => res.json())
        .then(async res => {
            if(!res){
                toast.error('No se encontraron datos en la respuesta del servidor')
                return this.setState({ [loading]: false })
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
                return this.setState({ [loading]: false })
            } else if( res.datos ){
                this.setState({ clientes: res.datos, total: res.total })
            }
            this.setState({ [loading]: false })
        })
        .catch(error => {
            this.setState({ [loading]: false })
            toast.error("Error al consultar la información, intente nuevamente", this.state.toaststyle)
        })
    }

    formularioCreacionTarifa(){
        const { loadingEsquemaPais, tipos_pago, habilitandoPago } = this.state

        if(loadingEsquemaPais){
            return <div>
                <Spinner animation='grow' />
                <h3>Cargando información</h3>
            </div>
        }

        return <Card style={{ width: '100%' }} className="mb-3">
        <Card.Body>
          <Row>
            <Col xs={12}>
                <h3>Habilitar método de pago</h3>
                <p>Selecciona el método de pago que deseas habilitar y has click en <b>habilitar</b></p>
            </Col>
            <Col md={4} className="mb-3">
            <label className='form-control-label'>Medio de pago</label>
            <select className='form-control' onChange={this.handleChangeTipoPago}>
                <option value="">Selecciona</option>
                {
                    tipos_pago.map((tipo,i) => {
                        return <option key={`tipopago-${i}`} value={tipo._id}>{tipo.title}</option>
                    })
                }
            </select>
            </Col> 
            <Col md={3} className="mb-3">
            <label className='form-control-label d-block'>Click para crear</label>
            { habilitandoPago === true ? <Spinner animation='grow' /> : <Button  variant="success" onClick={()=>this.habilitarTipoPago()} >HABILITAR</Button> }
            </Col>      
          </Row>          
        </Card.Body>
      </Card>
    }

    sinRegistros(){
        return <div className='p-5'>
            <Row className="justify-content-md-center">
                <Col md={6} className="text-center">
                <h4>Aún no tienes clientes</h4>
                <p>A medida que las personas vayan haciendo pedidos, sus datos personales quedarán guardados en este módulo</p>
                </Col>
            </Row>
        </div>
    }

    mostrarClientes(){
        const { clientes, total, loadingMediosPagoActivos } = this.state
        if(loadingMediosPagoActivos) return <Spinner animation='border' />
        if(clientes.length < 1) return this.sinRegistros()
        return <div>

            <h4> Se muestran {clientes.length} de {total} Clientes</h4>
            <table className='table'>
                <thead >
                    <tr>
                        <th>Nombres</th>
                        <th>Email</th>
                        <th>Teléfono</th>
                    </tr>
                </thead>
            {
                clientes.map((cliente,i) => {
                    return <tr key={`cliente-${cliente._id}`}>
                        <th>{cliente.nombre}</th>
                        <th>{cliente.email}</th>
                        <th>{cliente.movil}</th>
                        </tr>
                })
            }
            </table>
        </div>
    }

    render(){
        const { id_establecimiento } = this.state
        return(
            <div className="fluid">
       <Header/>
       <div className="container-fluid">
  <div className="row">
    <main className="col-md-12 ms-sm-auto col-lg-12 px-md-4 leftauto">
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
      <Link to={`/establecimiento-${id_establecimiento}`} className='text-dark' ><i className="fas fa-chevron-left"></i> Volver</Link>
      </div>
    <h1 className="h2"> Mis clientes </h1>
      <Card >
          <Card.Body>
          {this.mostrarClientes()}
          </Card.Body>
      </Card>
    </main>
  </div>
</div>
    </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        miusuario: state.miusuario
    }
}

export default connect(mapStateToProps)(Clientes);